import { DocumentIsogd } from "isogd-document-rest";

class DocumentRequestEditController {
    private document: DocumentIsogd;
}

export const DocumentRequestEditComponent: angular.IComponentOptions = {
    controller: DocumentRequestEditController,
    template: require('./documentRequestEdit.html'),
    bindings: {
        document: "<"
    }
};


// WEBPACK FOOTER //
// ./src/components/document/document-request/documentRequestEdit.ts